import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData } from '../../services/brochureUploadsServices';
import { Button, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { validateFile} from '../../utils/validators';

const Brochureuploads = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    meta_title: '',
    meta_description: '',
    uploadedfile: null,
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  

  // Fetch data from API
  const fetchData = useCallback(async () => {
     try{
    setLoading(true);
    const response = await getData();
    setData(response.data);
     }
     catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //validate the form 
    const validateForm = () => {
    const newErrors = {};
    if (!formData.meta_title) newErrors.meta_title = "Meta Title is required";
    if (!formData.meta_description) newErrors.meta_description = "Meta Description is required";
    if (formData.meta_title.length < 20 || formData.meta_title.length > 70) newErrors.meta_title = "Meta Title should be between 20 and 70 characters";
    if (formData.meta_description.length < 70 || formData.meta_description.length > 160) newErrors.meta_description = "Meta Description should be between 70 and 160 characters";
    if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Upload Brochure  is required";
  }
   setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };
  

  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
            const isPDF = file.type === "application/pdf";
            if (!isPDF) {
              setErrors((prev) => ({
                ...prev,
                [name]: "Only PDF files are allowed.",
              }));
              return;
            }
              const fileType = file.type.includes("image") ? "img" : "pdf";
              const isValid = await validateFile(file, setErrors,name,fileType);
              if (isValid) {
                updatedData[name] = file;
                updatedErrors[name] = '';
              }
              else{
                return ; // Don't update if invalid
              }
        } 
          else{
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }}
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate form data
      if (!validateForm()) {
          return
        }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('meta_title', formData.meta_title);
    form.append('meta_description', formData.meta_description);
    form.append('uploadedfile', formData.uploadedfile);
   if (modalType === 'edit') {
      const result = await updateData(form);
      if (result.status === 200) {
        fetchData();
        setShowModal(false);
        toast.success("Saved Successfully!", {position: 'top-right',});
      } else {
        toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',});
      }
    }
  }
  catch (error) {
        console.error("Error during form submission:", error);
    }
  };

  

  const openModal = (type, data = { id: null, sp_year: '', uploadedfile: null }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };


  
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

// Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered =  data?.filter(
      (data) =>
      data.meta_title.toLowerCase().includes(searchText.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [data
    , searchText]);

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
      
      {
        name: 'Brochure',
        selector: row => row.b_at,
        sortable: true,
        cell: row => row.b_at ? (
            <a className="btn btn-sm bg-success text-light rounded" href={row.b_at} target="_blank" rel="noopener noreferrer">
                <i className="mdi mdi-arrow-down-bold text-light"></i> Download
            </a>
        ) : 'No PDF Available',
    },
    

    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button
            className="me-2"
            variant="warning"
            size="sm"
            onClick={() => openModal('edit', {
              id: row.id,
              meta_title: row.meta_title,
              meta_description: row.meta_description,
              uploadedfile: row.b_at,
            })}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Basic Setup & File upload <b>/ Brochure</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>

          {/* Data Table for data */}
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
                <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                    onChange={handleSearchChange}
                />
                </div>
            }
            />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>     
                <Form.Group className="col-md-12 mb-3">
                  <Form.Label className='form-label-custom'>
                  Upload Brochure<small className='text-danger'> * </small><small className="text-primary">(Upload file size should be less than 8mb)</small>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="uploadedfile"
                    onChange={handleChange}
                    isInvalid={!!errors.uploadedfile}
                    accept="application/pdf"
                  />
                  <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-12 mb-3">
                    <Form.Label className='form-label-custom'>Meta Title<small className='text-danger'> * </small> <small className='text-primary'> Char Limit: 20 -70 | Current Char Count: {formData.meta_title.length}</small></Form.Label>
                    <Form.Control
                        type="text"
                        name="meta_title"
                        value={formData.meta_title}
                        onChange={handleChange}
                        isInvalid={!!errors.meta_title}
                    />
                    <Form.Control.Feedback type="invalid">{errors.meta_title}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-12 mb-3">
                    <Form.Label className='form-label-custom'>Meta Description<small className='text-danger'> * </small> <small className='text-primary'>Char Limit: 70 -160 | Current Char Count: {formData.meta_description.length}</small></Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={8}
                        name="meta_description"
                        value={formData.meta_description}
                        onChange={handleChange}
                        isInvalid={!!errors.meta_description}
                    />
                    <Form.Control.Feedback type="invalid">{errors.meta_description}</Form.Control.Feedback>
                    </Form.Group>
             
                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>
            
        </div>
        <Footer />
         </div>
      )}
      </div>
    </div>
  );
};

export default Brochureuploads;